<div *ngIf="groupData" class="drawer-infographic" [ngClass]="groupData?.blockClasses">
    <finder-component-header
        *ngIf="groupData.headerData"
        [data]="groupData.headerData"
        [hrDecoration]="groupData.hrDecoration"
    ></finder-component-header>
    <div class="drawer-infographic-cards">
        <finder-campaign-drawer-card
            *ngFor="let drawer of groupData.drawerGroup; let index = index"
            [cardData]="drawer"
            [cardIndex]="index + 1"
            [groupId]="groupData.blockId"
            [attr.data-mobile-index]="index + 1"
            [attr.data-desktop-index]="index | getCardOrder: groupData.count"
            class="infographic"
            [showCaret]="index + 1 === selectedCard"
        ></finder-campaign-drawer-card>
        <finder-campaign-drawer-detail
            data-container="infographic"
            [groupId]="groupData.blockId"
            [ngStyle]="css"
        ></finder-campaign-drawer-detail>
    </div>
</div>
